import React from "react";

import { fetchAccounts, FetchAccountsPayload } from "@admin/api/account";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useFetchAccounts = (payload?: FetchAccountsPayload) => {
    const [data, setData] = React.useState<API.Account[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [count, setCount] = React.useState(0);

    const refetch = React.useCallback(() => {
        setIsLoading(true);
        void fetchAccounts(payload)
            .then((response) => {
                setData(response.list);
                setCount(response.count);
            })
            .catch((error: Error) => showErrorToast(error.message))
            .finally(() => setIsLoading(false));
    }, [payload]);

    React.useEffect(() => {
        refetch();
    }, [refetch]);

    return { data, isLoading, count, setData, refetch };
};
